import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/lana-if/about/page.tsx")